import { api } from "../api";
import { OrderType } from "../../../types/order";

export const promoCodeEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    promoCode: build.mutation<OrderType, { orderId: string; promoCode: string }>({
      query: ({ orderId, promoCode }) => {
        return {
          url: `promocode/${orderId}`,
          method: "POST",
          body: {
            promocode: promoCode,
          },
        };
      },
      invalidatesTags: ["OrderSingle"],
    }),
  }),
  overrideExisting: true,
});

export const { usePromoCodeMutation } = promoCodeEndpoints;
